import { Box, Button, Container, Typography, useMediaQuery } from '@mui/material'
import { theme } from 'config'
import { observer } from 'mobx-react'
import { Course } from 'models'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthStore, RoutingStore } from 'stores'

export interface ICourseStartProps {
  authStore?:     AuthStore,
  routingStore?:  RoutingStore,
  course?:        Course,
  courseStarted?: ReactNode,
  description?:   string,
  onStart():      void,
}

export const CourseStartPage = (observer((props: ICourseStartProps) => {
  const { t } = useTranslation();
  const { description, onStart, courseStarted } = props;


  return (
    <Container className='courseStart' sx={{padding:{xs: 4, md: 5}, maxWidth: {md: 'md'}, minHeight: `calc(100vh - ${theme.topbarHeight}*2)`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Typography textAlign='justify'>{description}</Typography>
        <Box display='flex' justifyContent='center'>
          <Button sx={{mt: 3}} variant='contained' onClick = {onStart}>{courseStarted}</Button>
        </Box>
    </Container>
  );
}));
